import React, { useEffect, useState } from 'react';
import './Footer.css'
import { Link as Anchor, useLocation } from 'react-router-dom';
import logo from '../../images/logo.png'
import baseURL from '../url';
import { METODOS_PAGO_LISTA, parsearMetodosPago, renderIconoMetodo } from '../../utils/metodosPagoHelper';

const InstagramIcon = () => (
    <svg width="1em" height="1em" viewBox="0 0 448 512" fill="currentColor" style={{ verticalAlign: '-0.125em', display: 'inline-block' }}>
        <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/>
    </svg>
);

const FacebookIcon = () => (
    <svg width="1em" height="1em" viewBox="0 0 512 512" fill="currentColor" style={{ verticalAlign: '-0.125em', display: 'inline-block' }}>
        <path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"/>
    </svg>
);

const WhatsAppIcon = () => (
    <svg width="1em" height="1em" viewBox="0 0 448 512" fill="currentColor" style={{ verticalAlign: '-0.125em', display: 'inline-block' }}>
        <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/>
    </svg>
);

const TikTokIcon = () => (
    <svg width="1em" height="1em" viewBox="0 0 448 512" fill="currentColor" style={{ verticalAlign: '-0.125em', display: 'inline-block' }}>
        <path d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"/>
    </svg>
);

export default function Footer() {
    const [contactos, setContactos] = useState([]);
    const [metodosPagoTienda, setMetodosPagoTienda] = useState([]);
    const location = useLocation();

    // Obtener idTienda si estamos en una ruta de tienda (vía router o URL directa)
    const currentPath = location?.pathname || (typeof window !== 'undefined' ? window.location.pathname : '');
    const matchTienda = currentPath.match(/\/tienda\/(\d+)/i);
    const idTienda = matchTienda ? parseInt(matchTienda[1]) : null;

    useEffect(() => {
        cargarContacto();
        if (window.FB) {
            window.FB.XFBML.parse();
        } else if (!document.getElementById('facebook-jssdk')) {
            const script = document.createElement('script');
            script.id = 'facebook-jssdk';
            script.src = 'https://connect.facebook.net/es_LA/sdk.js#xfbml=1&version=v18.0';
            script.async = true;
            script.defer = true;
            script.crossOrigin = 'anonymous';
            script.onload = () => {
                if (window.FB) {
                    window.FB.XFBML.parse();
                }
            };
            document.body.appendChild(script);
        }
    }, []);

    useEffect(() => {
        if (!idTienda) {
            setMetodosPagoTienda([]);
            return;
        }

        const extraerMetodos = (t) => {
            if (!t) return [];
            const raw = t.metodosPago || t.metodos_pago;
            const ids = parsearMetodosPago(raw);
            return ids.map(id => METODOS_PAGO_LISTA.find(m => m.id === id)).filter(Boolean);
        };

        const handleTiendaCargada = (e) => {
            if (e.detail && (Number(e.detail.idTienda) === Number(idTienda) || !idTienda)) {
                const metodos = extraerMetodos(e.detail);
                if (metodos.length > 0) {
                    setMetodosPagoTienda(metodos);
                }
            }
        };

        window.addEventListener('tienda-cargada', handleTiendaCargada);

        // Fetch de respaldo si se accede directamente a la URL o recarga
        const cargarTiendaFooter = async () => {
            try {
                const res = await fetch(`${baseURL}/tiendasFrontend.php`);
                const data = await res.json();
                let tiendaEncontrada = (data.tiendas || []).find(t => Number(t.idTienda) === Number(idTienda));

                if (!tiendaEncontrada) {
                    const fallbackRes = await fetch(`${baseURL}/tiendaGet.php`);
                    const fallbackData = await fallbackRes.json();
                    tiendaEncontrada = (fallbackData.tiendas || []).find(t => Number(t.idTienda) === Number(idTienda));
                }

                if (tiendaEncontrada) {
                    const metodos = extraerMetodos(tiendaEncontrada);
                    setMetodosPagoTienda(metodos);
                }
            } catch (err) {
                console.error('Error al cargar métodos de pago en footer:', err);
            }
        };

        cargarTiendaFooter();

        return () => {
            window.removeEventListener('tienda-cargada', handleTiendaCargada);
        };
    }, [idTienda, currentPath]);

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setContactos(data.contacto.reverse()[0] || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    return (
        <div className={`FooterContain ${idTienda ? 'footerCuatroColumnas' : 'footerTresColumnas'}`}>
            <div className='footerText footerColBrand'>
                <div className='footerLogoTitle'>
                    <Anchor to='/' className='footerLogoLink' aria-label="Inicio">
                        <img src={logo} alt="Club Vende Más" className='footerLogoImg' width="50" height="50" />
                    </Anchor>
                    <h2>
                        {contactos.nombre}
                    </h2>
                </div>
                {contactos.descripcion_tienda && (
                    <p className='footerBrandDesc'>
                        {contactos.descripcion_tienda}
                    </p>
                )}
                <div className='socials'>
                    <Anchor to={contactos.instagram || '#'} target="_blank" title="Instagram"><InstagramIcon /></Anchor>
                    <Anchor 
                        to={contactos.tiktok && contactos.tiktok !== '#' 
                            ? (contactos.tiktok.startsWith('http') ? contactos.tiktok : `https://tiktok.com/@${contactos.tiktok.replace(/^@/, '')}`) 
                            : '#'} 
                        target="_blank" 
                        title="TikTok"
                    >
                        <TikTokIcon />
                    </Anchor>
                    <Anchor to={`tel:${contactos.telefono}`} target="_blank" title="WhatsApp"><WhatsAppIcon /></Anchor>
                    <Anchor to={contactos.facebook || '#'} target="_blank" title="Facebook"><FacebookIcon /></Anchor>
                </div>
            </div>
            <div className='footerText'>
                <h3>Contacto</h3>
                <Anchor to={`mailto:${contactos.email}`} target="_blank">{contactos.email}</Anchor>
                <Anchor to={`tel:${contactos.telefono}`} target="_blank">{contactos.telefono}</Anchor>
                <Anchor to={`https://www.google.com/maps?q=${encodeURIComponent(contactos.direccion)}`} target="_blank">{contactos.direccion}</Anchor>
            </div>
            {idTienda && (
                <div className='footerText footerMetodosPagoCol'>
                    <h3>Métodos de Pago Aceptados</h3>
                    {metodosPagoTienda.length > 0 ? (
                        <div className='footerMetodosPagoGrid'>
                            {metodosPagoTienda.map(metodo => (
                                <div
                                    key={metodo.id}
                                    className="badgeMetodoPagoView logoOnly"
                                    title={`${metodo.nombre} (${metodo.tipo})`}
                                >
                                    <div className="badgeMetodoPagoIcon">
                                        {renderIconoMetodo(metodo.iconoTipo)}
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p style={{ color: 'rgba(255, 255, 255, 0.75)', fontSize: '0.85rem', margin: 0 }}>
                            Cargando métodos de pago...
                        </p>
                    )}
                </div>
            )}
            <div className='footerText'>
                <div
                    className="fb-page"
                    data-href="https://www.facebook.com/clubvendemas360"
                    data-width="340"
                    data-hide-cover="false"
                    data-show-facepile="true"
                    data-adapt-container-width="true"
                    data-small-header="false"
                >
                    <blockquote cite="https://www.facebook.com/clubvendemas360" className="fb-xfbml-parse-ignore">
                        <a href="https://www.facebook.com/clubvendemas360" target="_blank" rel="noopener noreferrer">Club Vende Más</a>
                    </blockquote>
                </div>
            </div>
        </div>
    );
}
